<template>
    <div class="col backgroundForm">
        <div class="col col-md-6 offset-md-3">
            <div class="alert alert-danger" role="alert">
                <h4 class="alert-heading">Registro de Revistas y Juegos de Guerra</h4>        
                <hr>
                <p v-if=" (cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'FINANCIERO') "> Registro de las Unidades </p>
                <p v-else> Registro de la Unidad {{ cDtsUser.name_port | capitalize }}</p>
            </div>
        </div>
        
        <!-- aqui va si el usuario es administrador la lista de las unidades -->
         
        <transition name="fade" mode="out-in">
            <div class="form-row" v-if=" (cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'FINANCIERO') ">
                <div class="form-group col-12 col-md-4 offset-md-4">
                    <label for="nombre_embarcacion">Unidad</label>  
                            <!-- listar las capitanias -->
                    <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_ordop">
                        <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>                         
                </div>
            </div>
        </transition>

        <div class="form-row" v-if=" (cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'FINANCIERO') ">
            <div class="form-group col-12 col-md-4 offset-md-4">
                <label for="nombre_embarcacion">Gestión</label>  
                            <!-- listar las capitanias -->
                <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="gestion">
                    <option v-for="glist in gestiones_actividades" :value="glist.c" :key="glist.c">{{ glist.c }}</option>
                </select>                         
            </div>
        </div>
        
        <!-- inicio de los navs -->
        <nav>
            <div class="nav nav-pills" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-init-traffic" data-toggle="tab" href="#nav-reg" role="tab" aria-controls="nav-home" aria-selected="true">1. Registro Revista o Juego de Guerra</a>
                <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-delegado" role="tab" aria-controls="nav-home" aria-selected="true">2. Delegados y Observadores </a>
                <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-calificacion" role="tab" aria-controls="nav-home" aria-selected="true">3. Calificaciones </a>
                <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-document" role="tab" aria-controls="nav-home" aria-selected="true">4.Documento Digital </a>
            </div>
        </nav>
        
        <div class="tab-content" id="nav-tabContent">
                <br>
                <!-- first tab -->
                <div class="tab-pane fade show active" id="nav-reg" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6>GENERALES DE LA REVISTA o JUEGO DE GUERRA</h6>
                    <!-- <button class="btn btn-info" @click="mRellenaDtsAux"><font-awesome-icon icon="check-square" /> Rellenar Logistica, Comunicacion</button> -->
                    <hr>
                    
                    
                    <!-- formulario de la primera tab -->
                    
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="ordop_title">Periodo/Juego de Guerra <span class="required-text">*</span></label>
                            <input type="text" class="form-control" id="ordop_title" placeholder="BALA"  autocomplete="off" v-model="dts_dia.titulo">
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="type_ordop">Tipo Actividad <span class="required-text">*</span></label>
                            <select name="type_ordop" class="form-control" id="type_certificado" v-model="tipo_certificado">
                                <option :value="crt" v-for="crt in certificados" :key="crt.id">{{ crt.detail }}</option>
                            </select>
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="ordop_title">Fecha Inicio <span class="required-text">*</span></label>
                            <datetime v-model="dts_dia.fecha_inicio" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                            <!-- <input type="text" class="form-control" id="ordop_title" placeholder="BALA"  autocomplete="off" v-model="dts_dia.fecha_inicio"> -->
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="ordop_title">Fecha Final <span class="required-text">*</span></label>
                            <datetime v-model="dts_dia.fecha_final" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                        </div>
                    </div>
                    <hr>
                    <div class="form-row">
                        <label for="organizacion_ordop">Organización<span class="required-text">*</span></label>
                        <div class="input-group mb-3">
                            <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="port_select_person" @change="mChangePersonalCaptain(2)">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>   
                            <select class="custom-select" id="inputPersonSelect" v-model="person_select">
                                <option v-for="pc in persons_captain" :key="pc.personal_id" :value="pc">{{ pc.grade }} {{ pc.speciality }} {{ pc.complete }}</option>
                            </select>
                            <input type="text" class="form-control" placeholder="Cargo o Rol" aria-label="Cargo o Rol en operacion" aria-describedby="button-addon2" v-model="charge_temp">
                            <div class="input-group-append">
                                <button class="btn btn-outline-success" type="button" id="button-addon2" @click="mAppendPerson"><font-awesome-icon icon="plus" /></button>
                            </div>
                        </div>
                    </div>
                    
                    <label for="bandera_embarcacion">Listado de Personal incluido en la ORDOP<span class="required-text">*</span></label>
                    <div class="table-responsive col-12">
                        <table class="table table-sm" v-if="person_selecteds_ordop.length > 0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Grado y Nombre</th>
                                    <th>Cargo o Rol</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(pso, index) in person_selecteds_ordop" :key="pso.personal_id">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ pso.complete }}</td>
                                            <td>{{ pso.charge }}</td>
                                            <td><button class="btn btn-danger" @click="mDeleteList(index)"><font-awesome-icon icon="minus-circle" /></button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        <button class="btn btn-outline-success col-12 col-md-4 offset-md-4" :disabled="btn_r_dia" :bounce="btn_r_dia" v-if="person_selecteds_ordop.length>0" @click="mSaveRevistaJuego"><font-awesome-icon icon="save" size="2x" /></button>
                </div>
                
                <!-- second tab -->
                <div class="tab-pane fade" id="nav-delegado" role="tabpanel" aria-labelledby="nav-home-tab">
                    <h5>Formulario que permite incluir a los Delegados y/o Observadores de una Revista previamente registrada</h5>
                    <button class="btn btn-outline-warning col-12 col-md-4 offset-md-4" @click="mGetrevistasPendientes">Listar Revistas  <font-awesome-icon icon="list" /></button>
                    
                    <br><br>
                    <transition>
                        <div class="input-group" v-if="list_revistas.length > 0">
                            <label for="" class="form-control">Periodo</label>
                            <select class="form-control" name="revista_id" id="revista_id" v-model="revista_select">
                                    <option v-for="rvs in list_revistas" :value="rvs" :key="rvs.id_revista">{{ rvs.titulo }}</option>
                            </select>
                            <div class="input-group-append" id="button-addon4">
                                <button class="btn btn-outline-primary" @click="mVerificaListado">
                                    <font-awesome-icon icon="list" /> Verificar
                                </button>
                            </div>
                        </div>
                    </transition>
                    
                    <div v-if="form_lista_delegados">
                        <!-- aqui lista los delegados ya registrados -->
                         <div class="table-responsive">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Unidad</th>
                                        <th>Grado Nombre</th>
                                        <th>Cedula</th>
                                        <th>Cargo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ld, index) in lista_delegados" :key="ld.cedula_persona">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ ld.unidad }}</td>
                                        <td>{{ ld.completo_persona.toUpperCase() }}</td>
                                        <td>{{ ld.cedula_persona }}</td>
                                        <td>{{ ld.cargo }}</td>
                                    </tr>
                                </tbody>
                            </table>
                         </div>
                    </div>
                    
                    <div v-if="form_delegado">
                        <!-- aqui va el formulario para registrar a los delegados -->
                        <!-- revisar con la nueva estructura para la inlusion de los delegados y observadores de revista -->
                        <div class="form-row">
                        <label for="organizacion_ordop">Organización<span class="required-text">*</span></label>
                        <div class="input-group mb-3">
                            <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="port_select_person" @change="mChangePersonalCaptainInclude(2)">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>   
                            <select class="custom-select" id="inputPersonSelect" v-model="person_select_include">
                                <option v-for="pc in persons_captain_include" :key="pc.personal_id" :value="pc">{{ pc.grade }} {{ pc.speciality }} {{ pc.complete }}</option>
                            </select>
                            <input type="text" class="form-control" placeholder="Cargo o Rol" aria-label="Cargo o Rol en operacion" aria-describedby="button-addon2" v-model="charge_temp_include">
                            <div class="input-group-append">
                                <button class="btn btn-outline-success" type="button" id="button-addon2" @click="mAppendPersonInclude"><font-awesome-icon icon="plus" /></button>
                            </div>
                        </div>
                    </div>
                    
                    <label for="bandera_embarcacion">Listado de Personal incluido como observador y/o delegado<span class="required-text">*</span></label>
                    <div class="table-responsive col-12">
                        <table class="table table-sm" v-if="person_selecteds_ordop_include.length > 0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Grado y Nombre</th>
                                    <th>Cargo o Rol</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(pso, index) in person_selecteds_ordop_include" :key="pso.personal_id">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ pso.complete }}</td>
                                            <td>{{ pso.charge }}</td>
                                            <td><button class="btn btn-danger" @click="mDeleteListInclude(index)"><font-awesome-icon icon="minus-circle" /></button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        <button class="btn btn-outline-success col-12 col-md-4 offset-md-4" :disabled="btn_r_dia_include" v-if="person_selecteds_ordop_include.length>0" @click="mSaveRevistaJuegoInclude"><font-awesome-icon icon="save" :bounce="btn_r_dia_include" size="2x" /></button>
                        
                    </div>
                    
                </div>
                
                <!-- tercer tab -->
                <div class="tab-pane fade" id="nav-calificacion" role="tabpanel" aria-labelledby="nav-home-tab">
                    <h5>Formulario que permite registrar la Calificación exclusivamente de la Revista</h5>
                    <button class="btn btn-outline-warning col-12 col-md-4 offset-md-4" @click="mGetrevistasCalificacion">Listar Revistas  <font-awesome-icon icon="list" /></button>
                    
                    <br><br>
                    <transition>
                        <div class="input-group" v-if="list_calificacion.length > 0">
                            <label for="" class="form-control">Periodo</label>
                            <select class="form-control" name="revista_id" id="revista_id" v-model="revista_calificacion_select">
                                    <option v-for="rvs in list_calificacion" :value="rvs" :key="rvs.id_revista">{{ rvs.titulo }}</option>
                            </select>
                            <div class="input-group-append" id="button-addon4">
                                <button class="btn btn-outline-primary" @click="mVerificaListadoCalificacion">
                                    <font-awesome-icon icon="list" /> Verificar
                                </button>
                            </div>
                        </div>
                    </transition>
                    <hr>
                    <div>
                        <!-- aqui va el formulario con las opciones calificacion y su respectivo boton para aprobar la revista -->
                        <transition>
                            <div class="input-group" v-if="muestra_calificacion">
                                <label for="" class="form-control">Calificacion a la revista</label>
                                <select class="form-control" name="revista_id" id="revista_id" v-model="calificacion_selected">
                                        <option v-for="rvc in lista_calificaciones" :value="rvc" :key="rvc.id">{{ rvc.detail }}</option>
                                </select>
                                <div class="input-group-append" id="button-addon4">
                                    <button class="btn btn-outline-success" :disabled="btn_reg_calificacion" @click="mApruebaCalificacion">
                                        <font-awesome-icon icon="check" :bounce="btn_reg_calificacion" /> Aprobar
                                    </button>
                                </div>
                            </div>
                        </transition>
                        <!-- aqui lista los delegados ya registrados -->
                         <div class="table-responsive" v-if="lista_personas_calificacion.length > 0">
                            <table class="table table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>#</th>
                                        <th>Unidad</th>
                                        <th>Grado Nombre</th>
                                        <th>Cedula</th>
                                        <th>Cargo</th>
                                        <th>Calificación</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ld, index) in lista_personas_calificacion" :key="ld.cedula_persona" :class="ld.calificador==='S' ? 'table-danger': 'table-primary'">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ ld.unidad }}</td>
                                        <td>{{ ld.completo_persona.toUpperCase() }}</td>
                                        <td>{{ ld.cedula_persona }}</td>
                                        <td>{{ ld.cargo }}</td>
                                        <td>{{ ld.valor_calificacion !==0 ? ld.descripcion_calificacion:'SIN CALIFICACION' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                         </div>
                    </div>
 
                </div>
                
                <!-- cuarto tab -->
                <div class="tab-pane fade" id="nav-document" role="tabpanel" aria-labelledby="nav-home-tab">
                    <h5>Pantalla que permite adjuntar el archivo digital al Juego de Guerra o Revista</h5>
                    <button class="btn btn-outline-warning col-12 col-md-4 offset-md-4" @click="mGetRevistaJuego">Listar Actividades  <font-awesome-icon icon="list" /></button>
                    
                    <br><br>
                    <transition>
                        <div class="input-group" v-if="lista_juego_revista.length > 0">
                            <label for="" class="form-control">Periodo/Juego de Guerra</label>
                            <select class="form-control" name="revista_id" id="revista_id" :disabled="animacion_file" v-model="document_selected">
                                <option v-for="rjd in lista_juego_revista" :value="rjd" :key="rjd.id_revista">{{ rjd.titulo }} - {{ rjd.descripcion_tipo  }}</option>
                            </select>
                        </div>
                    </transition>
                    <hr>                    
                    <!-- aqui va el formulario de archivo con la actividad seleccionada -->
                    <div v-if="document_selected.id_revista>0">
                        <div class="form-row">
                            <label for="staticEmail" class="labelBlack">Titulo Revista/Juego de Guerra</label>    
                            <input type="text" readonly class="form-control-plaintext" id="staticTitleOrdop" v-model="document_selected.titulo">    
                        </div>
                        <div class="form-row">
                            <label for="staticEmail" class="labelBlack">Fechas </label>    
                            <span class="form-control">{{ $dateWrite(document_selected.fecha_inicio) }} al {{ $dateWrite(document_selected.fecha_conclusion) }}</span>
                        </div>
                        
                        <div class="form-group">
                            <label for="fileArchivoMensaje" class="labelBlack">Archivo Digital</label>
                            <input type="file" class="form-control-file" id="fileArchivoMensaje" @change="handleFileUpload" accept=".pdf">
                        </div>
                        <!-- aqui va el nuevo personal a incluir -->
                        <!-- fin de los antiguos personal -->
                        <p class="required-text" align="right" style="font-size:12px;">Campos Obligatorios (*)</p>
                        <button class="btn btn-outline-warning col-12 col-md-4 offset-md-4" :disabled="animacion_file" @click="mRegisterDocument">
                            <font-awesome-icon icon="upload" size="3x" :spin="animacion_file" />
                        </button>
                </div>
            </div>
        </div>
    </div>
    <!-- end div principal -->
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';

export default {
    data(){
        return{
            list_revistas:[],
            gestion:0,
            gestiones_actividades:[],
            captain_ordop:0,
            persons_captain:[],
            persons_captain_include:[],
            gestion:[],
            ports:[],
            certificados:[],
            tipo_certificado:{
              id:0,
              detail:''  
            },
            dts_dia:{
                titulo:'',
                tipo_id:0,
                tipo_descripcion:'',
                fecha_inicio:'',
                fecha_final:'',
                organizacion:[]
            },
            port_select_person:0,
            person_selecteds_ordop:[],
            person_select:{},
            person_selecteds_ordop_include:[],
            person_select_include:{},
            charge_temp:null,
            charge_temp_include:null,
            btn_r_dia:false,
            form_delegado:false,
            form_lista_delegados:false,
            lista_delegados:[],
            revista_select:{},
            revista_calificacion_select:{},
            btn_r_dia_include:false,
            list_calificacion:[],
            lista_personas_calificacion:[],
            muestra_calificacion:false,
            calificacion_aux:{},
            lista_calificaciones:[],
            calificacion_selected:{
                id:0
            },
            btn_reg_calificacion:false,
            select_file:null,
            animacion_file:false,
            document_selected:{id:0},
            lista_juego_revista:[],
            juegos_revista_select:{
                id_revista:0
            }
        }
    },
    mounted(){
        this.verifyCategory();
        this.callCaptains();
        this.getYears();
        // this.mCallTypesCategorys();
    },
    methods:{
        async mGetRevistaJuego(){
            try {
                this.lista_juego_revista=[];
                this.document_selected.id_revista=0;
                if(this.captain_ordop > 0 && this.gestion>0){
                    let revistas_aux = await axios.get(`listaJuegoRevista/${this.captain_ordop}/${this.gestion}?api_token=${Vue.auth.getToken()}`);
                    // console.log('aqui tenemos la lista de las revistas')
                    // console.log(revistas_aux);
                    if(revistas_aux.data.length>0){
                        this.lista_juego_revista=revistas_aux.data;
                    }else{
                        toastr.warning(`No se ha encontrado registros en la Unidad Indicada`);
                    }
                }else{
                    toastr.warning(`Porfavor señala la unidad y la gestión que desea buscar los juegos o revistas`);
                }
            } catch (error) {
                console.log(error);
            }
        },
        async mApruebaCalificacion(){
            //aqui validamos la calificacion que se registrara
            if(this.calificacion_selected.id>0){
                let message = {
                    title: `Periodo ${this.revista_calificacion_select.titulo}`,
                    body: `¿Desea Registrar la calificación de <b>${this.calificacion_selected.detail}</b>, para el periodo <b>${this.revista_calificacion_select.titulo}</b>?, el mismo sera registrado para todo el grupo.`
                };
                // validar que los datos esten completos
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // registramos y validamos el presupuesto general en la bd
                            try {
                                // let btn_send=document.getElementById(this.btn_r_ordop);
                                let new_calificacion={
                                    id_revista:this.revista_calificacion_select.id_revista,
                                    calificacion:this.calificacion_selected.id,
                                    descripcion_calificacion:this.calificacion_selected.detail
                                }
                                this.btn_reg_calificacion=true;

                                let regCalificacion=await axios.post(`registerCalificacion?api_token=${Vue.auth.getToken()}`, qs.stringify(new_calificacion));
                                
                                setTimeout(()=>{                                
                                    if(regCalificacion.data.status){
                                        toastr.success(regCalificacion.data.respuesta);
                                        this.list_calificacion=[];
                                        this.lista_personas_calificacion=[];
                                        this.muestra_calificacion=false;
                                    }                                
                                    this.btn_reg_calificacion=false;
                                },1000)

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error')
                                    // this.inactiveModal(this.id_modal_progress);
                                    this.btn_reg_calificacion = false;
                                }, 3000)
                            }
                        }else{
                            console.log('No se guardo la actividad')
                            // console.log(this.dts_ordop);
                        }
                    })
            }else{
                toastr.warning(`Por favor seleccione una calificacion para la revista`);
            }
        },
        async mVerificaListadoCalificacion(){
            let rev= this.revista_calificacion_select;
            this.lista_personas_calificacion=[];
            this.muestra_calificacion=false;
          try {
            // aqui verificamos si el estado de la revista cuenta o no con asignaciones
            if(rev.valor_calificacion===0){
                this.muestra_calificacion=true;
            }
            let delegados_aux=await axios.get(`listaPersonasRevista/${rev.id_revista}?api_token=${Vue.auth.getToken()}`);
            console.log(delegados_aux);
            this.lista_personas_calificacion=delegados_aux.data;
          } catch (error) {
            console.log(error);
          }  
        },
        async mVerificaListado(){
            let rev= this.revista_select
            this.lista_delegados=[];
            this.form_lista_delegados=false;
            this.form_delegado=false;
          try {
            // aqui verificamos si el estado de la revista cuenta o no con asignaciones
            if(rev.calificador==='N'){
                this.form_delegado=true;
                this.form_lista_delegados=false;
                // aqui realizamos la inclusion de los delegados a la revista con el formulario
            }else{
                this.form_lista_delegados=true;
                this.form_delegado=false;
                // aqui llamamos al servidor para listar a los delegados ya registrados
                let delegados_aux=await axios.get(`delegadosList/${rev.id_revista}?api_token=${Vue.auth.getToken()}`);
                console.log(delegados_aux);
                this.lista_delegados=delegados_aux.data;
            }
          } catch (error) {
            console.log(error);
          }  
        },
        async mGetrevistasPendientes(){
          try {
            this.list_revistas=[];
            this.person_selecteds_ordop=[];
            this.lista_personas_calificacion=[];
            this.person_selecteds_ordop_include=[];
            this.lista_delegados=[];
            if(this.captain_ordop > 0 && this.gestion>0){
                let revistas_aux = await axios.get(`listaRevistas/${this.captain_ordop}/${this.gestion}?api_token=${Vue.auth.getToken()}`);
                console.log('aqui tenemos la lista de las revistas')
                console.log(revistas_aux);
                if(revistas_aux.data.length>0){
                    this.list_revistas=revistas_aux.data;
                }else{
                    toastr.warning(`No se ha encontrado registros en la Unidad Indicada`);
                }
            }else{
                toastr.warning(`Porfavor señala la unidad y la gestión que desea buscar las revistas`);
            }
          } catch (error) {
            console.log(error);
          }  
        },
        async mGetrevistasCalificacion(){
          try {
            this.list_calificacion=[];
            this.lista_personas_calificacion=[];
            this.muestra_calificacion=false;
            if(this.captain_ordop > 0){
                let revistas_aux = await axios.get(`listaRevistaCalificacion/${this.captain_ordop}/${this.gestion}?api_token=${Vue.auth.getToken()}`);
                console.log('aqui tenemos la lista de las revistas');
                console.log(revistas_aux);
                if(revistas_aux.data.length>0){
                    this.list_calificacion=revistas_aux.data;
                }else{
                    toastr.warning(`Verifica que las Revistas ya cuenten con Delegados, Observadores y otros`);
                }
            }else{
                toastr.warning(`Porfavor señala la unidad que desea buscar las revistas`);
            }
          } catch (error) {
            console.log(error);
          }  
        },
        getYears(){
            let ya=new Date();
            this.gestion=ya.getFullYear();
            
            const init=2015;
            this.gestiones_actividades=[];
            for(let i=init; i<=this.gestion; i++){
                let ai={c:i};
                this.gestiones_actividades.push(ai);
            }
            // this.dts_millas.date_init=`${ya.getFullYear()}-${ya.getDay()}-${ya.getMonth()}`;
        },
        async callCaptains(){
            let ya=new Date();

            let year_select=ya.getFullYear();
            const init=2018;
            this.years=[];
            for(let i=init; i<= year_select; i++){
                let ai={c:i};
                this.years.push(ai);
            }
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            let t_certificado=await axios.get(`globals/pardia?api_token=${Vue.auth.getToken()}`);
            this.certificados=t_certificado.data;
            if(this.cDtsUser.roleAssign === 'OPERADOR'){
                // llamamos al personal de su capitania
                let callPers= await axios.get(`personalCaptains/${this.cDtsUser.portId}?api_token=${Vue.auth.getToken()}`);
                // console.log(callPers.data);
                this.persons_captain=callPers.data;
            }
            
            let calificaciones_aux=await axios.get(`globals/cali?api_token=${Vue.auth.getToken()}`);
            this.lista_calificaciones=calificaciones_aux.data; 

            this.ports=cp.data;
        },
        verifyCategory(){
            this.captain_ordop=this.cDtsUser.role===4 ? this.cDtsUser.portId : 0;
            // this.captain_process_ordop=this.captain_ordop;
            // console.log(`la capitanias es ${this.captain}`);
        },
        async mChangePersonalCaptain(typeSearch=1){
            this.persons_captain=[];
            if(typeSearch===1){
                this.person_selecteds_ordop=[];
                this.person_select={};
                this.charge_temp=null;
            }
            let captain_select=this.port_select_person > 0 ? this.port_select_person : this.captain_ordop;
            let callPers= await axios.get(`personalCaptains/${captain_select}?api_token=${Vue.auth.getToken()}`);
                // console.log(callPers.data);
            this.persons_captain=callPers.data;
        },
        async mChangePersonalCaptainInclude(typeSearch=1){
            this.persons_captain_include=[];
            if(typeSearch===1){
                this.person_selecteds_ordop_include=[];
                this.person_select_include={};
                this.charge_temp_include='';
            }
            let captain_select=this.port_select_person > 0 ? this.port_select_person : this.captain_ordop;
            let callPers= await axios.get(`personalCaptains/${captain_select}?api_token=${Vue.auth.getToken()}`);
                // console.log(callPers.data);
            this.persons_captain_include=callPers.data;
        },
        mAppendPerson(){
            // anadimos a la persona en lista de participantes de la ORDOP
            
            let ips=this.person_selecteds_ordop.findIndex(dts => dts.personal_id === this.person_select.personal_id);
            
            if(ips === -1){
                // agregamos a la persona
                if(this.charge_temp !==null && this.charge_temp !==''){
                    let tempper={
                        personal_id:this.person_select.personal_id,
                        complete:`${this.person_select.grade} ${this.person_select.speciality} ${this.person_select.complete}`,
                        charge:this.charge_temp.toUpperCase(),
                        id_unidad:this.person_select.id_unidad,
                        unidad:this.person_select.name_port
                    }
                    this.person_selecteds_ordop.push(tempper);
                    this.charge_temp=null;
                }else{
                    toastr.info(`Para agregar a la persona seleccionada ${this.person_select.complete} debe indicar un cargo o Rol`, 'Alerta');
                }
            }else{
                // no agregamos dado que ya existe la persona
                toastr.warning(`La persona seleccionada ${this.person_select.complete} ya se encuentra en la lista`, 'Alerta');
            }
        },
        async mAppendPersonInclude(){
            // anadimos a la persona en lista de participantes de la ORDOP
            console.log(this.person_select_include.personal_id);
            let bpersona= await axios.get(`buscaPersonaActividad/${this.person_select_include.personal_id}/${this.revista_select.id_revista}?api_token=${Vue.auth.getToken()}`);
            
            // console.log(bpersona);
            
            if(!bpersona.data){
                
                let ips=this.person_selecteds_ordop_include.findIndex(dts => dts.personal_id === this.person_select_include.personal_id);
                
                if(ips === -1){
                    // agregamos a la persona
                    if(this.charge_temp_include !==null && this.charge_temp_include !==''){
                        let tempper={
                            personal_id:this.person_select_include.personal_id,
                            complete:`${this.person_select_include.grade} ${this.person_select_include.speciality} ${this.person_select_include.complete}`,
                            charge:this.charge_temp_include.toUpperCase(),
                            id_unidad:this.person_select_include.id_unidad,
                            unidad:this.person_select_include.name_port
                        }
                        this.person_selecteds_ordop_include.push(tempper);
                        this.charge_temp_include='';
                    }else{
                        toastr.info(`Para agregar a la persona seleccionada ${this.person_select_include.complete} debe indicar un cargo o Rol`, 'Alerta');
                    }    
                }else{
                    toastr.warning(`La persona seleccionada ${this.person_select_include.complete} ya se encuentra en la lista de observadores y/o delegados`, 'Alerta');
                }
                
            }else{
                    // no agregamos dado que ya existe la persona
                    toastr.warning(`La persona seleccionada ${this.person_select_include.complete} ya se encuentra en la lista verifique si no fue añadido previamente`, 'Alerta');
            }
        },
        mValidateRevistaJuego(){
            if(this.captain_ordop===0){
                toastr.warning(`Seleccione una Unidad de Origen de Registro`);
                return false;
            }
            if(this.dts_dia.titulo.trim()===''){
                toastr.warning(`indique el nombre del Juego de Guerra o Periodo`);
                return false;
            }
            if(this.tipo_certificado.id===0){
                toastr.warning('seleccione si el registro es Juego de Guerra o Revista');
                return false;
            }
            
            let adi=this.dts_dia.fecha_inicio.split('T');
            this.dts_dia.fecha_inicio=adi[0];

            if( this.dts_dia.fecha_inicio === null || !(this.dts_dia.fecha_inicio.length === 10) ){
                toastr.error('La fecha de Inicio es incorrecta', 'Error');
                return false;
            }
            
            let adf=this.dts_dia.fecha_final.split('T');
            this.dts_dia.fecha_final=adf[0];

            if( this.dts_dia.fecha_final === null || !(this.dts_dia.fecha_final.length === 10) ){
                toastr.error('La fecha de conclusion es incorrecta', 'Error');
                return false;
            }
            
            if(this.dts_dia.fecha_final < this.dts_dia.fecha_inicio){
                toastr.error('La fecha de conclusion no puede ser menor a la fecha de inicio', 'Error');
                return false;
            }
            
            if(this.person_selecteds_ordop.length===0){
                toastr.warning(`Seleccione minimamente una persona para esta actividad`);
                return false;
            }
          return true;
        },
        async mSaveRevistaJuego(){
            if(this.mValidateRevistaJuego()){
                let message = {
                    title: `${this.tipo_certificado.detail}`,
                    body: `¿Desea Registrar el/la <b>${this.tipo_certificado.detail}</b>, que lleva por Título el periodo/Juego de Guerra <b>${this.dts_dia.titulo}</b>?`
                };
                // validar que los datos esten completos
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // registramos y validamos el presupuesto general en la bd
                            try {
                                // let btn_send=document.getElementById(this.btn_r_ordop);
                                this.dts_dia.organizacion=[];
                                this.dts_dia.organizacion=JSON.stringify(this.person_selecteds_ordop);
                                this.dts_dia.tipo_id=this.tipo_certificado.id;
                                this.dts_dia.tipo_descripcion=this.tipo_certificado.detail;
                                
                                this.btn_r_dia = true;
                                // this.activeModal(this.id_modal_progress);
                                // let s_dts_ordop=await axios.post(`registerOrdopInit/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_ordop));

                                let regJuegoRevista=await axios.post(`registerActividad/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_dia));
                                
                                setTimeout(()=>{                                
                                    if(regJuegoRevista.data.status){
                                        toastr.success(regJuegoRevista.data.respuesta);
                                        this.dts_dia.organizacion=[];
                                        this.dts_dia.titulo='';
                                        this.dts_dia.tipo_id=0;
                                        this.dts_dia.tipo_descripcion='';
                                        this.tipo_certificado.id=0;
                                        this.tipo_certificado.descripcion='';
                                        this.person_selecteds_ordop=[];
                                    }                                
                                    this.btn_r_dia=false;
                                },1000)

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error')
                                    // this.inactiveModal(this.id_modal_progress);
                                    this.btn_r_dia = false;
                                }, 3000)
                            }
                        }else{
                            console.log('No se guardo la actividad')
                            // console.log(this.dts_ordop);
                        }
                    })
                }else{
                    console.log('debe validarse los campos')
                }
        },
        async mSaveRevistaJuegoInclude(){
            
                // console.log(this.revista_select);
                let message = {
                    title: `Añadir Nuevas Personas`,
                    body: `¿Desea Incluir a el/la <b>${this.revista_select.titulo}</b>, a la cantidad de ${this.person_selecteds_ordop_include.length} personas?</b>?`
                };
                // validar que los datos esten completos
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // registramos y validamos el presupuesto general en la bd
                            try {
                                // let btn_send=document.getElementById(this.btn_r_ordop);
                                let revista_juego_include={
                                    id_revista:this.revista_select.id_revista,
                                    new_organization:JSON.stringify(this.person_selecteds_ordop_include)
                                }
                                
                                this.btn_r_dia_include = true;
                                // this.activeModal(this.id_modal_progress);
                                // let s_dts_ordop=await axios.post(`registerOrdopInit/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_ordop));

                                let regDelegado=await axios.post(`registerDelegado?api_token=${Vue.auth.getToken()}`, qs.stringify(revista_juego_include));
                                
                                setTimeout(()=>{                                
                                    if(regDelegado.data.status){
                                        this.btn_r_dia_include=false;
                                        toastr.success(regDelegado.data.respuesta);
                                        this.form_delegado=false;
                                        this.form_lista_delegados=false;
                                        this.lista_personas_calificacion=[];
                                        this.person_selecteds_ordop_include=[];
                                        this.mGetrevistasPendientes();
                                        this.mVerificaListado();
                                        
                                    }                                
                                },1000)

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error')
                                    // this.inactiveModal(this.id_modal_progress);
                                    this.btn_r_dia_include = false;
                                }, 3000)
                            }
                        }else{
                            console.log('No se guardo la actividad')
                            // console.log(this.dts_ordop);
                        }
                    })
        },
        mDeleteList(i){
            
            // let ips2=this.person_selecteds_ordop.findIndex(dts => dts.personal_id === this.person_select.personal_id);
            // if(ips2 >=0){
                // agregamos a la persona
                this.person_selecteds_ordop.splice(i, 1);
            // }
        },
        mDeleteListInclude(i){
            
            // let ips2=this.person_selecteds_ordop.findIndex(dts => dts.personal_id === this.person_select.personal_id);
            // if(ips2 >=0){
                // agregamos a la persona
                this.person_selecteds_ordop_include.splice(i, 1);
            // }
        },
        mValidateDocument(){
            if(this.select_file===null){
                toastr.warning("Debe seleccionar un documento PDF, no mas de 2 MB a enviar al servidor");
                return false;
            }
            return true;
        },
        async mRegisterDocument(){
            try {
            
                if(this.mValidateDocument()){
                    this.animacion_file=true;
                    const formData = new FormData();
                    formData.append('file', this.select_file);
                    formData.append('id_revista', this.document_selected.id_revista);
                    
                    let regDocument=await axios.post(`regDocumentDia?api_token=${Vue.auth.getToken()}`, formData);
                    if(regDocument.data.status){
                        toastr.success(`${regDocument.data.respuesta}`);
                        this.document_selected.id_revista=0;
                    }else{
                        toastr.error(`${regDocument.data.respuesta}`)
                    }
                    setTimeout(()=>{
                        this.animacion_file=false;
                    },2000)
                }
                
            } catch (error) {
                console.log(error);
                this.animacion_file=false;
            }
                        
        },
        handleFileUpload(event) {
            const MAXIMO_TAMANIO_BYTES = 2000000; // 1MB = 1 millón de bytes
            let temp_archivo=event.target.files[0];

            if (temp_archivo.size <= MAXIMO_TAMANIO_BYTES) {
                this.select_file = event.target.files[0];
            } else {
                const tamanioEnMb = MAXIMO_TAMANIO_BYTES / 1000000;
                toastr.warning(`El tamaño máximo es ${tamanioEnMb} MB`);
                event.target.value='';
                // Validación pasada. Envía el formulario o haz lo que tengas que hacer
            }
        },
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ordop/OrdopDia.vue